import { useEffect } from "react";

const useOnScrollOutside = (ref, handleScroll) => {
  useEffect(() => {
    const handleScrollOutside = (e) => {
      if (!ref.current || ref.current.contains(e.target)) return;
      handleScroll(e);
    };

    document.addEventListener("scroll", handleScrollOutside, true);

    return () => {
      document.removeEventListener("scroll", handleScrollOutside, true);
    };
  }, [handleScroll, ref]);
};

export default useOnScrollOutside;
